import { Component, State, h } from '@stencil/core';
import { Model } from '../../types';
import { getModels } from '../../utils/api';

@Component({
  tag: 'kia-modeldemo',
  shadow: false,
})
export class KiaModel {
  @State() models: Model[] = [];
  @State() activeModelCode: string | null = null;

  async componentWillLoad() {
    const { data, status } = await getModels();
    if (data && status === 200) {
      this.models = data;
      this.activeModelCode = data[0].code;
    }
  }

  getExample() {
    return `<kia-model code="${this.activeModelCode}" ></kia-model>`;
  }

  render() {
    return (
      <div>
        <div style={{ margin: '3rem auto', maxWidth: '940px', padding: '0 1rem' }}>
          <h3>Byt modell</h3>
          <select
            aria-label="Byt modell"
            style={{ display: 'block', width: '100%', padding: '1rem', maxWidth: '940px' }}
            onChange={e => (this.activeModelCode = (e.target as HTMLSelectElement).value)}
          >
            {this.models.map(c => (
              <option value={c.code}>{c.name}</option>
            ))}
          </select>
          <h3>Lägg in följande snippet</h3>
          <div style={{ background: 'black', color: 'white', padding: '1rem' }}>
            <p>{this.getExample()}</p>
            <p>{` <script type="module" src="https://cdn.jsdelivr.net/npm/@afonso-digital/kia-web-components@latest/dist/kia-web-components/kia-web-components.esm.js"></script>`}</p>
          </div>
        </div>
        <kia-model key={this.activeModelCode} code={this.activeModelCode} />
      </div>
    );
  }
}
